// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Header component styling.
 * Colors and dimensions use the design tokens from global styles.scss.
 */
:host {
  display: block;
  position: relative;
  z-index: 20;
}

#header.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  min-height: 68px;
  padding: 0.75rem 1.5rem;
  box-sizing: border-box;
  position: relative;
  overflow: visible;
  background: var(--ca-header-bg, #ffffff);
  border-bottom: 1px solid var(--ca-header-border, #e9edf3);
  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));
}
#header.app-header #logo.header-brand {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
  gap: 1rem;
  min-width: 0;
  margin-right: auto;
}
#header.app-header #logo.header-brand .header-logo {
  display: block;
  width: auto;
  height: 40px;
  max-width: min(190px, 24vw);
  object-fit: contain;
}
#header.app-header .header-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.5rem;
  flex: 0 0 auto;
  min-width: 0;
  margin: 0;
  font-weight: 500;
}
#header.app-header .header-action-slot {
  display: flex;
  align-items: center;
}
#header.app-header .header-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  padding: 0;
  color: var(--ca-text-secondary, #4b5870);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-md, 8px);
  cursor: pointer;
  transition: color 150ms ease, background-color 150ms ease, border-color 150ms ease;
}
#header.app-header .header-icon-button i {
  font-size: 1.45rem;
  line-height: 1;
}
#header.app-header .header-icon-button:hover {
  color: var(--ca-primary, #0e2e80);
  background-color: var(--ca-bg-secondary, #eef2f8);
}
#header.app-header .header-icon-button:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}
#header.app-header .header-action-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  min-height: 40px;
  padding: 0.6rem 0.9rem;
  color: var(--ca-text-secondary, #4b5870);
  background: transparent;
  border: 1px solid transparent;
  border-radius: var(--ca-radius-sm, 6px);
  font: inherit;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 1.25;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: color 150ms ease, background-color 150ms ease, border-color 150ms ease, box-shadow 150ms ease;
}
#header.app-header .header-action-button i {
  flex: 0 0 auto;
  font-size: 1rem;
  line-height: 1;
}
#header.app-header .header-action-button:hover:not(:disabled) {
  color: var(--ca-primary, #0e2e80);
  background-color: var(--ca-bg-secondary, #eef2f8);
}
#header.app-header .header-action-button:focus-visible {
  outline: 2px solid var(--ca-primary-light, #2850ad);
  outline-offset: 2px;
}
#header.app-header .header-action-button:disabled {
  color: var(--ca-text-muted, #8c96a8);
  background-color: var(--ca-bg-tertiary, #e7ecf5);
  cursor: not-allowed;
  opacity: 0.8;
}
#header.app-header .user-management-btn,
#header.app-header .products-menu-button {
  color: var(--ca-text-primary, #172033);
}
#header.app-header .products-menu-wrapper {
  position: relative;
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}
#header.app-header .products-menu-caret {
  color: var(--ca-text-tertiary, #6f7b91);
  font-size: 0.7rem !important;
  transition: transform 150ms ease;
}
#header.app-header .products-menu-button[aria-expanded=true] .products-menu-caret {
  transform: rotate(180deg);
}
#header.app-header #menu.header-profile {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex: 0 0 auto;
  min-width: 40px;
  margin-left: 0.5rem;
  color: var(--ca-text-secondary, #4b5870);
}
#header.app-header #menu.header-profile .header-profile-content {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
}

@media (max-width: 900px) {
  #header.app-header {
    gap: 0.5rem;
    padding-inline: 1rem;
  }
  #header.app-header #logo.header-brand {
    gap: 0.625rem;
  }
  #header.app-header .header-actions {
    gap: 0.25rem;
  }
  #header.app-header .header-action-button {
    padding-inline: 0.65rem;
  }
}
@media (max-width: 680px) {
  #header.app-header {
    flex-wrap: wrap;
    min-height: 64px;
    padding: 0.625rem 0.75rem;
  }
  #header.app-header #logo.header-brand {
    order: 1;
  }
  #header.app-header #logo.header-brand .header-logo {
    height: 34px;
    max-width: 150px;
  }
  #header.app-header #menu.header-profile {
    order: 2;
    margin-left: 0;
  }
  #header.app-header .header-actions {
    order: 3;
    justify-content: flex-end;
    width: 100%;
    margin: 0;
    padding-top: 0.5rem;
    border-top: 1px solid var(--ca-header-border, #e9edf3);
  }
  #header.app-header .header-action-button {
    min-height: 38px;
    font-size: 0.8125rem;
  }
}
@media (max-width: 380px) {
  #header.app-header .header-actions {
    justify-content: space-between;
  }
  #header.app-header .header-action-button {
    gap: 0.4rem;
    padding-inline: 0.5rem;
    font-size: 0.78rem;
  }
}
@media (prefers-reduced-motion: reduce) {
  #header.app-header,
  #header.app-header * {
    transition-duration: 0.01ms !important;
    animation-duration: 0.01ms !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/navigation/header/header.component.scss"],"names":[],"mappings":"AAyEA;;;EAAA;AAKA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,wCAAA;EACA,yDAAA;EACA,gEAAA;AA1EF;AA6EE;EACE,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;AA3EJ;AA6EI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,mBAAA;AA3EN;AAgFE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;AA9EJ;AAiFE;EACE,aAAA;EACA,mBAAA;AA/EJ;AAkFE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,wCAAA;EACA,uBAAA;EACA,6BAAA;EACA,uCAAA;EACA,eAAA;EACA,kFACE;AAjFN;AAqFI;EACE,kBAAA;EACA,cAAA;AAnFN;AAsFI;EACE,iCAAA;EACA,iDAAA;AApFN;AAuFI;EACE,mDAAA;EACA,mBAAA;AArFN;AAyFE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,gBAAA;EACA,sBAAA;EACA,wCAAA;EACA,uBAAA;EACA,6BAAA;EACA,uCAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,yGACE;AAxFN;AA6FI;EACE,cAAA;EACA,eAAA;EACA,cAAA;AA3FN;AA8FI;EACE,iCAAA;EACA,iDAAA;AA5FN;AA+FI;EACE,mDAAA;EACA,mBAAA;AA7FN;AAgGI;EACE,oCAAA;EACA,gDAAA;EACA,mBAAA;EACA,YAAA;AA9FN;AAkGE;;EAEE,sCAAA;AAhGJ;AAmGE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAjGJ;AAoGE;EACE,uCAAA;EACA,4BAAA;EACA,gCAAA;AAlGJ;AAqGE;EACE,yBAAA;AAnGJ;AAuGE;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,wCAAA;AArGJ;AAuGI;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AArGN;;AA0GA;EACE;IACE,WAAA;IACA,oBAAA;EAvGF;EAyGE;IACE,aAAA;EAvGJ;EA0GE;IACE,YAAA;EAxGJ;EA2GE;IACE,uBAAA;EAzGJ;AACF;AA6GA;EACE;IACE,eAAA;IACA,gBAAA;IACA,yBAAA;EA3GF;EA6GE;IACE,QAAA;EA3GJ;EA6GI;IACE,YAAA;IACA,gBAAA;EA3GN;EA+GE;IACE,QAAA;IACA,cAAA;EA7GJ;EAgHE;IACE,QAAA;IACA,yBAAA;IACA,WAAA;IACA,SAAA;IACA,mBAAA;IACA,sDAAA;EA9GJ;EAiHE;IACE,gBAAA;IACA,oBAAA;EA/GJ;AACF;AAmHA;EAEI;IACE,8BAAA;EAlHJ;EAqHE;IACE,WAAA;IACA,sBAAA;IACA,kBAAA;EAnHJ;AACF;AAuHA;EACE;;IAEE,sCAAA;IACA,qCAAA;EArHF;AACF","sourcesContent":["// #header {\r\n//   display: flex;\r\n//   width: 100%;\r\n//   padding: 20px 30px;\r\n//   box-sizing: border-box;\r\n//   justify-content: space-between;\r\n//   box-shadow: 3px 3px 3px #ccc;\r\n\r\n//   #logo {\r\n//     display: flex;\r\n//     align-items: center;\r\n\r\n//     i {\r\n//       margin-right: 25px;\r\n//     }\r\n\r\n//     img {\r\n//       margin-right: 3px;\r\n//     }\r\n//   }\r\n\r\n//   #menu {\r\n//     display: flex;\r\n//     gap: 20px;\r\n\r\n//     a {\r\n//       text-decoration: none;\r\n//       color: #737373;\r\n//       font-size: 16px;\r\n//       cursor: pointer;\r\n\r\n//       &:hover {\r\n//         color: #1a1a86;\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n\r\n// .btn-style {\r\n//   background: none;\r\n//   border: none;\r\n//   cursor: pointer;\r\n//   // font: inherit;\r\n//   color: inherit;\r\n//   padding: 0;\r\n\r\n//   &:hover {\r\n//     color: #1a1a86;\r\n//     text-shadow: 0 2px 4px rgba(2, 56, 121, 0.5);\r\n//   }\r\n\r\n// }\r\n\r\n\r\n// .user-management-btn {\r\n//   text-decoration: none;\r\n//   color: #333333;\r\n//   cursor: pointer;\r\n\r\n//   &:hover {\r\n//     color: #1a1a86;\r\n//   }\r\n\r\n//   &:disabled {\r\n//     color: #b3b3b3;          // lighter grey text\r\n//     background-color: #f5f5f5; // subtle grey background\r\n//     border-radius: 6px;      // optional: give disabled a boxed look\r\n//     cursor: not-allowed;\r\n//   }\r\n// }\r\n\r\n\r\n\r\n/*\r\n * Header component styling.\r\n * Colors and dimensions use the design tokens from global styles.scss.\r\n */\r\n\r\n:host {\r\n  display: block;\r\n  position: relative;\r\n  z-index: 20;\r\n}\r\n\r\n#header.app-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 1rem;\r\n  width: 100%;\r\n  min-height: 68px;\r\n  padding: 0.75rem 1.5rem;\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  overflow: visible;\r\n\r\n  background: var(--ca-header-bg, #ffffff);\r\n  border-bottom: 1px solid var(--ca-header-border, #e9edf3);\r\n  box-shadow: var(--ca-shadow-sm, 0 2px 6px rgba(7, 17, 46, 0.06));\r\n\r\n  // Logo remains on the left.\r\n  #logo.header-brand {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex: 0 0 auto;\r\n    gap: 1rem;\r\n    min-width: 0;\r\n    margin-right: auto;\r\n\r\n    .header-logo {\r\n      display: block;\r\n      width: auto;\r\n      height: 40px;\r\n      max-width: min(190px, 24vw);\r\n      object-fit: contain;\r\n    }\r\n  }\r\n\r\n  // Actions are grouped immediately before the profile.\r\n  .header-actions {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: 0.5rem;\r\n    flex: 0 0 auto;\r\n    min-width: 0;\r\n    margin: 0;\r\n    font-weight: 500;\r\n  }\r\n\r\n  .header-action-slot {\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n\r\n  .header-icon-button {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex: 0 0 auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    padding: 0;\r\n    color: var(--ca-text-secondary, #4b5870);\r\n    background: transparent;\r\n    border: 1px solid transparent;\r\n    border-radius: var(--ca-radius-md, 8px);\r\n    cursor: pointer;\r\n    transition:\r\n      color 150ms ease,\r\n      background-color 150ms ease,\r\n      border-color 150ms ease;\r\n\r\n    i {\r\n      font-size: 1.45rem;\r\n      line-height: 1;\r\n    }\r\n\r\n    &:hover {\r\n      color: var(--ca-primary, #0e2e80);\r\n      background-color: var(--ca-bg-secondary, #eef2f8);\r\n    }\r\n\r\n    &:focus-visible {\r\n      outline: 2px solid var(--ca-primary-light, #2850ad);\r\n      outline-offset: 2px;\r\n    }\r\n  }\r\n\r\n  .header-action-button {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 0.625rem;\r\n    min-height: 40px;\r\n    padding: 0.6rem 0.9rem;\r\n    color: var(--ca-text-secondary, #4b5870);\r\n    background: transparent;\r\n    border: 1px solid transparent;\r\n    border-radius: var(--ca-radius-sm, 6px);\r\n    font: inherit;\r\n    font-size: 0.875rem;\r\n    font-weight: 500;\r\n    line-height: 1.25;\r\n    white-space: nowrap;\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n    transition:\r\n      color 150ms ease,\r\n      background-color 150ms ease,\r\n      border-color 150ms ease,\r\n      box-shadow 150ms ease;\r\n\r\n    i {\r\n      flex: 0 0 auto;\r\n      font-size: 1rem;\r\n      line-height: 1;\r\n    }\r\n\r\n    &:hover:not(:disabled) {\r\n      color: var(--ca-primary, #0e2e80);\r\n      background-color: var(--ca-bg-secondary, #eef2f8);\r\n    }\r\n\r\n    &:focus-visible {\r\n      outline: 2px solid var(--ca-primary-light, #2850ad);\r\n      outline-offset: 2px;\r\n    }\r\n\r\n    &:disabled {\r\n      color: var(--ca-text-muted, #8c96a8);\r\n      background-color: var(--ca-bg-tertiary, #e7ecf5);\r\n      cursor: not-allowed;\r\n      opacity: 0.8;\r\n    }\r\n  }\r\n\r\n  .user-management-btn,\r\n  .products-menu-button {\r\n    color: var(--ca-text-primary, #172033);\r\n  }\r\n\r\n  .products-menu-wrapper {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    flex: 0 0 auto;\r\n  }\r\n\r\n  .products-menu-caret {\r\n    color: var(--ca-text-tertiary, #6f7b91);\r\n    font-size: 0.7rem !important;\r\n    transition: transform 150ms ease;\r\n  }\r\n\r\n  .products-menu-button[aria-expanded='true'] .products-menu-caret {\r\n    transform: rotate(180deg);\r\n  }\r\n\r\n  // Profile remains at the far right.\r\n  #menu.header-profile {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    flex: 0 0 auto;\r\n    min-width: 40px;\r\n    margin-left: 0.5rem;\r\n    color: var(--ca-text-secondary, #4b5870);\r\n\r\n    .header-profile-content {\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      min-width: 0;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 900px) {\r\n  #header.app-header {\r\n    gap: 0.5rem;\r\n    padding-inline: 1rem;\r\n\r\n    #logo.header-brand {\r\n      gap: 0.625rem;\r\n    }\r\n\r\n    .header-actions {\r\n      gap: 0.25rem;\r\n    }\r\n\r\n    .header-action-button {\r\n      padding-inline: 0.65rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 680px) {\r\n  #header.app-header {\r\n    flex-wrap: wrap;\r\n    min-height: 64px;\r\n    padding: 0.625rem 0.75rem;\r\n\r\n    #logo.header-brand {\r\n      order: 1;\r\n\r\n      .header-logo {\r\n        height: 34px;\r\n        max-width: 150px;\r\n      }\r\n    }\r\n\r\n    #menu.header-profile {\r\n      order: 2;\r\n      margin-left: 0;\r\n    }\r\n\r\n    .header-actions {\r\n      order: 3;\r\n      justify-content: flex-end;\r\n      width: 100%;\r\n      margin: 0;\r\n      padding-top: 0.5rem;\r\n      border-top: 1px solid var(--ca-header-border, #e9edf3);\r\n    }\r\n\r\n    .header-action-button {\r\n      min-height: 38px;\r\n      font-size: 0.8125rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  #header.app-header {\r\n    .header-actions {\r\n      justify-content: space-between;\r\n    }\r\n\r\n    .header-action-button {\r\n      gap: 0.4rem;\r\n      padding-inline: 0.5rem;\r\n      font-size: 0.78rem;\r\n    }\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  #header.app-header,\r\n  #header.app-header * {\r\n    transition-duration: 0.01ms !important;\r\n    animation-duration: 0.01ms !important;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
